/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function () {
				// JavaScript to be fired on all pages

				/** GLOBAL VARIABLES */
				var body = document.querySelector('body');
				/** END GLOBAL VARIABLES */


				/** SKIP LINK NAVIGATION */
				$('#skip-to-content').click(function (event) {
					// strip the leading hash and declare
					// the content we're skipping to
					var skipTo = "#" + this.href.split('#')[1];
					// Setting 'tabindex' to -1 takes an element out of normal 
					// tab flow but allows it to be focused via javascript
					$(skipTo).attr('tabindex', -1).on('blur focusout', function () {
						// when focus leaves this element, 
						// remove the tabindex attribute
						$(this).removeAttr('tabindex');
					}).focus(); // focus on the content container
				});
				/** END SKIP LINK NAVIGATION */


				/* HEADER SCROLL EFFECT */
				// Reference: http://tympanus.net/codrops/2013/06/06/on-scroll-animated-header/
				var animatedHeader = (function () {
					var didScroll = false,
						scrollOffset = 20;
					function scrollY() {
						return window.pageYOffset || document.documentElement.scrollTop;
					}
					function scrollPage() {
						var sy = scrollY();
						if (sy > scrollOffset) {
							body.classList.add('scroll-triggered');
						}
						else {
							body.classList.remove('scroll-triggered');
						}
						didScroll = false;
					}
					function init() {
						window.addEventListener('load', scrollPage);
						window.addEventListener('scroll', function (event) {
							if (!didScroll) {
								didScroll = true;
								// setTimeout(scrollPage, 250);
								scrollPage();
							}
						}, false);
					}
					init();
				})();
				/* END HEADER SCROLL EFFECT */

				/** RESPONSIVE NAV OPEN/CLOSE **/
				var mobileNav       = document.querySelector('#mobile-nav');
				var mobileNavButton = document.querySelector('#mobile-nav-icon');

				// Toggle menu icon
				if (mobileNavButton) {
					mobileNavButton.addEventListener('click', function () {
						body.classList.toggle('mobile-nav-open');
					});
				}

				$('#mobile-nav-icon').on('click', function() {
			  		$(this).toggleClass('mobile-active');
			  	});

				// Close menu if page is clicked (not menu item)
				if (mobileNav) {
					mobileNav.addEventListener('click', function (e) {
						// Don't hide if click is on a child element (nav link)
						if (e.target !== this) {
							return;
						}
						mobileNavButton.classList.toggle('opened');
						$("#nav-toggle").prop('checked', false);
					});

					// Disable click on mobile
					$("#mobile-nav > .menu > .menu-item-has-children > a").on("click", function (e) {
						e.preventDefault();

						$(this).parent().toggleClass("menu-item-opened");
					});

				}
				/** END RESPONSIVE NAV OPEN/CLOSE **/


				/** SHOW AND HIDE SEARCH BAR **/
				var searchButton     = $('#search-button'),
					headerMain       = $('#header-main'),
					headerSearch     = $('#header-search'),
					searchClose      = $('#search-close');

				searchButton.click(function () {
					headerMain.fadeToggle('fast', function () {
						headerSearch.fadeToggle('slow');
						// Focus on input for all browsers except IE11. They have a placeholder text bug.
						if ((window.ActiveXObject) && !("ActiveXObject" in window)) {
							headerSearch.find('input[type="text"]').focus();
						}
					});
					return false;
				});
				searchClose.click(function () {
					headerSearch.fadeToggle('fast', function () {
						headerMain.fadeToggle('slow');
					});
				});
				// Shake Animation
				function shake(div) {
					var interval = 100;
					var distance = 10;
					var times = 4;
					$(div).css('position', 'relative');
					for (var iter = 0; iter < (times + 1); iter++) {
						$(div).animate({ left: ((iter % 2 === 0 ? distance : distance * -1)) }, interval);
					}
					$(div).animate({ left: 0 }, interval);
				}
				// Search Submit
				headerSearch.submit(function (e) {
					var s = $(this).find('input[type="text"]');
					if (!s.val()) {
						e.preventDefault();
						shake($(this).find('input[type="text"]'));
						$(this).find('input[type="text"]').focus();
					}
				});
				/** END SHOW OR HIDE SEARCH BAR **/


				/** MASTHEAD PRGRESSIVE IMAGES **/
				var masthead = document.querySelector('.masthead'),
					placeholderOverlay = document.querySelector('.placeholder-overlay');

				if (masthead && placeholderOverlay) {
					// Load full size image. When loaded, fade our placeholder add it as bg to masthead
					var img = new Image();
					img.src = masthead.dataset.imageSrc;
					img.onload = function () {
						placeholderOverlay.classList.add('fade-out');
						masthead.style.backgroundImage = "url(" + img.src + ")";
					};
				}
				/** END MASTHEAD PRGRESSIVE IMAGES **/


				/** ANIMATED ANCHOR LINKS **/
				$('a[href*="#"]:not([href="#"])').click(function (e) {
					if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
						var target = $(this.hash);
						var $this = this;
						var header = $('header.banner');
						var wpAdminBar = $('#wpadminbar');
						var fixedHeaderOffset = parseInt(header.outerHeight()) - parseInt(header.css("padding-top").replace("px", ""));
						// If we're logged in and WP ADmin Bar exists, add it to the offset
						if ( wpAdminBar.length ) {
							fixedHeaderOffset += parseInt(wpAdminBar.outerHeight());
						}
						target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
						if (target.length) {
							$('html,body').animate({
								scrollTop: (target.offset().top - fixedHeaderOffset)
							}, 500, function () {
								if (history.pushState) {
									history.pushState(null, null, $this.hash);
								}
								else {
									location.hash = $this.hash;
								}
							});
							e.preventDefault();
						}
					}
				});
				/** END ANIMATED ANCHOR LINKS **/


				/* SMOOTH SCROLL TO TOP */
				$('#goTop').on('click', function(e){
					e.preventDefault();
				    $("html, body").animate({scrollTop: 0}, 500);
				});

				// $('#goTop').hide();
				$(window).scroll(function() {
				 var scroll = $(window).scrollTop();
				 var top    = $('#goTop');
				 if (scroll > 400) {
					 top.addClass('show');
				 } else {
				 	top.removeClass('show');
				 }
				});


				/* SLICK CAROUSEL */
				var carousel = $('.carousel__posts');
				carousel.slick({
					'arrows'      : true,
					'dots'        : true,
					adaptiveHeight: true,
					'appendDots'  : $('.carousel__posts-dots'),
					responsive    : [
					{
						breakpoint: 768,
						settings: {
							arrows        : false,
							adaptiveHeight: true
						}
					}]
				});


				// Magnific popup - lightbox images
				$(document).ready(function() {
				  $('.image-link').magnificPopup({type:'image'});
				});


				/* NUMBER TICKER UPON VIEW */
				// IMPORTANT: Requires Waypoint.js and Counterup.js (Enqueued from JSDelivr)
				var numberTickers = $('.ticker');
				if (numberTickers.length) {
					numberTickers.counterUp({
						time: 700
					});
				}
				/* END NUMBER TICKER UPON VIEW */

			},
			finalize: function () {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		// Home page
		'home': {
			init: function () {
				// JavaScript to be fired on the home page
			},
			finalize: function () {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		// About us page, note the change from about-us to about_us.
		'about_us': {
			init: function () {
				// JavaScript to be fired on the about us page
			}
		},
		// Donate
		'donate': {
			init: function() {
				// setup
				var otherGift   = $('#other_gift-wrap'),
					otherSff    = $('#other-wrap'),
					anonymous   = $('#anonymous_donation-wrap');

				// Rearrange field placement
				otherGift.removeClass('give-ffm-form-row-full');
				anonymous.insertAfter('#give-email-wrap').removeClass('give-ffm-form-row-full');
				$('.give-total-wrap').insertAfter('#give-donation-level-button-wrap');
				$('#where_i_want_to_give-wrap').insertAfter('#ffm_section-wrap').removeClass('give-ffm-form-row-full');
				$('#ffm_html-wrap').insertBefore('.give-recurring-donors-choice').removeClass('give-ffm-form-row-full');
				$('#give_checkout_user_info legend').text('Your Information');
				$('#give_cc_fields legend').text('Payment Information');
				$('#give-amount').val('');

				$('#ffm_section-wrap').insertBefore('#ffm_html-wrap');
				$('#where_i_want_to_give-wrap').insertBefore('#ffm_html-wrap');

				// Tributes
				$('.give-tributes-grab-info label[for="give-tributes-mail-a-card-18"]').text('Please send acknowledgement');
				$('.give-tributes-grab-info label[for="give-tributes-send-an-ecard-18"]').text('Please email acknowledgement');
				$('.give-tributes-yes').text('Yes');
				$('.give-tributes-no').text('No');
				// $('.give-recurring-donors-choice').insertBefore('#give-tributes-dedicate-donation-18');
				// otherGift.insertBefore('#give-tributes-dedicate-donation-18').removeClass('give-ffm-form-row-full');
				// $('#ffm_section-wrap').insertBefore('#give-tributes-dedicate-donation-18').removeClass('give-ffm-form-row-full');

				// Conditional 'other' field display - How did you hear about SFF?
				otherSff.hide();
				$('#ffm-how_did_you_hear_about_sff-18').change(function(){
					if( $(this).children('option[value="Other"]').is(':selected') ) {
						otherSff.show();
					} else {
						otherSff.hide();
					}
				});


				// Pre-select campaign
				var getUrlParameter = function getUrlParameter(sParam) {
					var sPageURL        = decodeURIComponent(window.location.search.substring(1)),
					sURLVariables       = sPageURL.split('&'),
			        sParameterName,
			        i;

				    for (i = 0; i < sURLVariables.length; i++) {
				        sParameterName = sURLVariables[i].split('=');

				        if (sParameterName[0] === sParam) {
				            return sParameterName[1] === undefined ? true : sParameterName[1];
				        }
				    }
				}

				var campaign       = getUrlParameter('campaign');
				var campaignSelect = $('#ffm-where_i_want_to_give-18 option');
				
				campaignSelect.each(function(){
					var option = $(this);
					var value = option.val();
					if( value == campaign ) {
						option.attr("selected","selected");
					}
				});
			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function (func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function () {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
